import React from "react";
import "./PageNotFound.css";
import {useNavigate} from "react-router-dom";
import MagneticButton from "../Buttons/MagneticButton/MagneticButton";

const PageNotFound = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate("/"); // fallback to home
    }
  };

  return (
    <div className="not-found-section">
      <div className="hero-spotlight"></div>
      <svg aria-hidden="true" className="svg-grid">
        <defs>
          <pattern
            id="hero"
            width="80"
            height="80"
            x="50%"
            y="-1"
            patternUnits="userSpaceOnUse"
          >
            <path d="M.5 200V.5H200" fill="none"></path>
          </pattern>
        </defs>
        <rect
          width="100%"
          height="100%"
          strokeWidth="0"
          fill="url(#hero)"
          className="my-rect"
        ></rect>
      </svg>

      <div className="not-found-container container">
        <div className="glitch">
          <span aria-hidden="true">404</span>
          404
          <span aria-hidden="true">404</span>
        </div>

        <div className="not-found-texts">
          <h3>Oops.! you've lost</h3>
          <h6>We can't find the page that you're looking for</h6>
        </div>

        <MagneticButton
          onClick={handleClick}
          className="tt-btn tt-btn-outline tt-magnetic-item"
        >
          <i className="ri-arrow-left-line"></i> Go Back
        </MagneticButton>
      </div>
    </div>
  );
};

export default PageNotFound;
